import actions from "./actions";
import RestaurantSchemeTablesForReservations from "../../components/User/RestaurantSchemeComponent/RestaurantSchemeTablesForReservations";

const initState = {
  tables: [],
  regions: [],
  touchSaleTablesPerRegion: [],
};

export default function restaurantSchemaReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.CREATE_NEW_RESERVATION_TABLE_SUCCESS:
      return {
        ...state,
        tables: [...state.tables, action.table],
      };

    case actions.EDIT_RESERVATION_TABLE_SUCCESS:
      const updatedTables = state.tables.map((table) =>
        table.id === action.table.id
          ? {
              ...table,
              x: action.table.x,
              y: action.table.y,
              direction: action.table.direction,
              scale: action.table.scale,
              shape: action.table.shape,
              seatsCount: action.table.seatsCount,
            }
          : table
      );
      return {
        ...state,
        tables: updatedTables,
      };

    case actions.DELETE_RESERVATION_TABLE_SUCCESS:
      return {
        ...state,
        tables: state.tables.filter(
          (table) => table.id !== action.table.id
        ),
      };

    case actions.GET_RESERVATION_TABLE_SUCCESS:
      return {
        ...state,
        tables: action.tables,
      };

    case actions.CREATE_NEW_REGION_SUCCESS:
      const newRegion = {
        label: action.region.name,
        key: action.region.regionId,
        closable: false,
        backgroundImage: action.region.backgroundImage,
        children: (
          <RestaurantSchemeTablesForReservations
            regionId={action.region.regionId}
          />
        ),
      };
      return {
        ...state,
        regions: [...state.regions, newRegion],
      };

    case actions.GET_REGIONS_SUCCESS:
      const regions = action.regions.map((region) => ({
        label: region.name,
        key: region.regionId,
        closable: false,
        backgroundImage: region.backgroundImage,
        children: (
          <RestaurantSchemeTablesForReservations
            regionId={region.regionId}
            backgroundImage={region.backgroundImage}
          />
        ),
      }));

      return {
        ...state,
        regions: regions,
      };

    case actions.EDIT_REGION_SUCCESS:
      const updatedRegions = state.regions.map((region) =>
        region.key === action.region.regionId
          ? {
              ...region,
              label: action.region.name,
            }
          : region
      );

      return {
        ...state,
        regions: updatedRegions,
      };

    case actions.DELETE_REGION_SUCCESS:
      return {
        ...state,
        regions: state.regions.filter(
          (region) => region.key !== action.region.regionId
        ),
      };

    case actions.REORDER_REGIONS_SUCCESS:
      const reorderedRegions = action.regions.map((region) => ({
        label: region.name,
        key: region.regionId,
        closable: false,
        backgroundImage: region.backgroundImage,
        children: (
          <RestaurantSchemeTablesForReservations
            regionId={region.regionId}
            backgroundImage={region.backgroundImage}
          />
        ),
      }));

      return {
        ...state,
        regions: reorderedRegions,
      };

    case actions.GET_TOUCHSALE_TABLES_PER_REGION_SUCCESS:
      return {
        ...state,
        touchSaleTablesPerRegion: action.touchsaleTables,
      };

    case actions.BUSY_OR_FREE_TABLE_SUCCESS:
      return {
        ...state,
        tables: state.tables.map((table) =>
          table.id === action.editTable.id
            ? { ...table, busy: action.editTable.busy }
            : table
        ),
      };

    default:
      return state;
  }
}
